import { Link, useLocation } from "react-router-dom";
import Button from "../../Shared/Button/Button";
import GreenTick from "../../Shared/SvgIcons/GreenTick";

const WonAndBoughtOptions = () => {
  const location = useLocation();
  const path = location.pathname;
  const isSoldItem = path === "/user/sold-items";

  return (
    <div className="flex flex-col items-center justify-center border-l border-lightGray p-2.5">
      <p className="mb-2 font-pop text-2xl font-semibold text-blue">
        R299,999.00
      </p>
      {isSoldItem ? (
        <GreenTick className="mb-2.5 h-10 w-10" />
      ) : (
        <picture className="h-14 w-14">
          <img src="/assets/images/win.png" alt="" />
        </picture>
      )}
      <p
        className={`mb-3 rounded-[5px] bg-quantityColor py-1 px-3 font-pop text-sm font-semibold text-${
          isSoldItem ? "secondary" : "primary"
        }`}
      >
        {isSoldItem ? "Sold" : "Won"}
      </p>
      <Button
        text={isSoldItem ? "View Buyer Info" : "View Seller Info"}
        variant="blue"
        className="mb-2 !pt-2 !pb-2 !text-xs"
      />

      <Link to="/auctionlisting" className="flex w-full justify-center">
        <Button
          text="View Item"
          variant="primary"
          className="pt-2 pb-2 !text-xs"
        />
      </Link>
    </div>
  );
};

export default WonAndBoughtOptions;
